import { setSpreadGroupsPerProductUidAction } from 'editor/src/store/variants/slice';

export default setSpreadGroupsPerProductUidAction;
